var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SellHeader',{attrs:{"img_header":_vm.header_image,"header":"รายงานการขาย","link_back":"sell/all"}}),_c('Sell_report_all')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }